import { render, staticRenderFns } from "./PageRoleForm.vue?vue&type=template&id=56f1436f&scoped=true"
import script from "./PageRoleForm.vue?vue&type=script&lang=js"
export * from "./PageRoleForm.vue?vue&type=script&lang=js"
import style0 from "./PageRoleForm.vue?vue&type=style&index=0&id=56f1436f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1436f",
  null
  
)

export default component.exports